import React from "react";
import { Modal, Row, Col, Typography, Card, Divider } from "antd";

const { Text, Title } = Typography;

type BankDetails = {
  bankName: string;
  accountNumber: string;
  bankHolderName: string;
  ifsc: string;
  branchName: string;
  branchAddress: string;
};

type BankModalProps = {
  open: boolean;
  onCancel: () => void;
  initialData: {
    clientId: string;
    address: string;
    email: string;
    mobileNumber: string;
    bankDetails: BankDetails;
    clientName: string;
    companyName: string;
  } | null;
};

const labelStyle: React.CSSProperties = {
  fontWeight: 500,
  color: "#444",
};

const valueStyle: React.CSSProperties = {
  fontWeight: 600,
  color: "#000",
};

const BankModal: React.FC<BankModalProps> = ({
  open,
  onCancel,
  initialData,
}) => {
  if (!initialData || !initialData.bankDetails) return null;
  const { bankDetails } = initialData;

  return (
    <Modal
      title={<Title level={4}>Lender Bank & Address Details</Title>}
      open={open}
      onCancel={onCancel}
      footer={null}
      width={700}
    >
      <Card bordered={false}>
        <Title level={5}>Lender Address Details</Title>
        <Row gutter={[0, 16]}>
          <Col span={10}>
            <Text style={labelStyle}>Email:</Text>
          </Col>
          <Col span={14}>
            <Text style={valueStyle}>{initialData.email}</Text>
          </Col>

          <Col span={10}>
            <Text style={labelStyle}>Mobile Number:</Text>
          </Col>
          <Col span={14}>
            <Text style={valueStyle}>{initialData.mobileNumber}</Text>
          </Col>

          <Col span={10}>
            <Text style={labelStyle}>Full Address:</Text>
          </Col>
          <Col span={14}>
            <Text style={valueStyle}>{initialData.address}</Text>
          </Col>
        </Row>
        <Divider />

        <Title level={5}>Bank Details</Title>
        <Row gutter={[0, 16]}>
          <Col span={10}>
            <Text style={labelStyle}>Bank Name:</Text>
          </Col>
          <Col span={14}>
            <Text style={valueStyle}>{bankDetails.bankName}</Text>
          </Col>

          <Col span={10}>
            <Text style={labelStyle}>Account Number:</Text>
          </Col>
          <Col span={14}>
            <Text style={valueStyle}>{bankDetails.accountNumber}</Text>
          </Col>

          <Col span={10}>
            <Text style={labelStyle}>Account Holder Name:</Text>
          </Col>
          <Col span={14}>
            <Text style={valueStyle}>{bankDetails.bankHolderName}</Text>
          </Col>

          <Col span={10}>
            <Text style={labelStyle}>IFSC Code:</Text>
          </Col>
          <Col span={14}>
            <Text style={valueStyle}>{bankDetails.ifsc}</Text>
          </Col>

          <Col span={10}>
            <Text style={labelStyle}>Branch Name:</Text>
          </Col>
          <Col span={14}>
            <Text style={valueStyle}>{bankDetails.branchName}</Text>
          </Col>

          <Col span={10}>
            <Text style={labelStyle}>Branch Address:</Text>
          </Col>
          <Col span={14}>
            <Text style={valueStyle}>{bankDetails.branchAddress}</Text>
          </Col>
        </Row>
      </Card>
    </Modal>
  );
};

export default BankModal;
